import axios from 'axios';
import React from 'react';
import { globalConfig } from '../configuration/config';
import { useTranslation } from "react-i18next";
import { clearLocalStorageExceptOptimizationPresets } from './optimization-presets';

const clearCookies = () => {
  const cookies = document.cookie.split(';');
  cookies.forEach((cookie) => {
    const cookieName = cookie.split('=')[0].trim();
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
};

const logoutUserAccount = async () => {
  try {
    // Завершаем сессию на сервере
    await axios.get(`${globalConfig.config.common.identity.replace(/\/+$/, '')}/endsession`, {
      withCredentials: true,
    });

    // Очищаем локальные cookies
    clearCookies();

    // Очищаем локальное и сессионное хранилище
    clearLocalStorageExceptOptimizationPresets(localStorage);
    sessionStorage.clear();

    // Перенаправляем на страницу авторизации
    window.location.href = '/auth';
  } catch (error) {
    console.error('Ошибка при выходе из аккаунта:', error);
  }
};

const Loguot = () => {
  const { t } = useTranslation();

  return (
    <div>
      <a id="logout" className="menu-item" onClick={logoutUserAccount}>
        { t("menu.logout") }
      </a>
    </div>
  );
};

export default Loguot;
